import authService from "@/services/authService";
import iframeAuthService from "@/services/iframeAuthService";
import { EmailLoginRequest, IframeUserLoginRequest, SendOtpRequest, VerifyOtpRequest } from "@/types/authService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userKeys } from "../user/useUserQueries";

export const useDeleteAccount = () => {
  const queryClient = useQueryClient();
  return useMutation<string, Error>({
    mutationFn: () => authService.deleteAccount(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [] });
    },
  });
};

export const useIframeLogin = () => {
  return useMutation({
    mutationFn: (data: IframeUserLoginRequest) => iframeAuthService.loginUser(data),
  });
};

export const useLogin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: EmailLoginRequest) => authService.loginWithEmail(data),
    onSuccess: data => {
      if (data.user) {
        queryClient.setQueryData(userKeys.user, data.user);
      }
    },
  });
};

export const useLogout = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      queryClient.clear();
    },
  });
};

export const useSendOtp = () => {
  return useMutation({
    mutationFn: (data: SendOtpRequest) => authService.sendOtp(data),
  });
};

export const useVerifyOtp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: VerifyOtpRequest) => authService.verifyOtp(data),
    onSuccess: data => {
      if (data.user) {
        queryClient.setQueryData(userKeys.user, data.user);
      }
    },
  });
};

export const useAuthenticateToken = () => {
  return useMutation({
    mutationFn: () => authService.authenticateToken(),
  });
};
